function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { getPropertyStatusForType, PropertyStatus, RentListingTypeKeys, SaleListingTypeKeys } from '@domain-group/fe-allhomes-library/lib/node';
import { MultiValueSearchQueryField } from '../multi-value-search-query-field';
import { parseSlugs } from '../../utils/parse-slugs';
var DefaultForListingType = {
  SALES_RESIDENTIAL: ['FOR_SALE', 'UNDER_OFFER'],
  DEVELOPMENTS_RESIDENTIAL: ['FOR_SALE', 'UNDER_OFFER'],
  RENTAL_RESIDENTIAL: ['AVAILABLE_FOR_RENT', 'UNDER_APPLICATION']
};
export class PropertyStatusFilter extends MultiValueSearchQueryField {
  get validListingTypes() {
    return [...SaleListingTypeKeys, ...RentListingTypeKeys, 'DEVELOPMENTS_RESIDENTIAL'];
  }
  constructor(searchOptions, values) {
    super(searchOptions, getPropertyStatusForType(searchOptions.listingType), values, DefaultForListingType[searchOptions.listingType] || []);
    _defineProperty(this, "urlSlug", PropertyStatusFilter.urlSlug);
  }
  static fromUrlParameters(searchOptions, q, p) {
    var values = p.listingType === 'sold' ? [...new Set([PropertyStatus.SOLD.name, ...(parseSlugs(PropertyStatus, q[PropertyStatusFilter.urlSlug]) || [])])] : parseSlugs(PropertyStatus, q[PropertyStatusFilter.urlSlug]);
    return new PropertyStatusFilter(searchOptions, values);
  }
}
_defineProperty(PropertyStatusFilter, "urlSlug", 'status');